<template>

  <div class="more bg-white min-main border-black items-center justify-between" @click="toArticle(20)">
    <div></div>
    <h3 class="font16">
      <slot />
    </h3>
    <svg-icon icon-class="Path 2492"></svg-icon>
  </div>

</template>

<script>
export default {
  methods: {
    toArticle(typeId) {
      this.$router.push({
        path: `/article?typeId=${typeId}`,
      });
    }
  }
}
</script>

<style lang="less" scoped>
.more {
  padding: 6px 16px;
  box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.16);
  border-width: 2px;
  border-radius: 45px;
  cursor: pointer;

  h3 {
    font-family: NotoSansCJKTC;
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.8px;
    color: #630106;
  }

  .svg-icon {
    width: 5.1px;
    height: 10.1px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/expert/more.vue